import { getMakeAClaimUrl } from "../../services/MakeAClaimService";
import { AUTHORISE_TREATMENT } from "../../components/makeAClaim/Constants";
import { MEDICAL_TREATMENT } from "./../../components/makeAClaim/Constants";

export const UPDATE_MAKE_A_CLAIM = "UPDATE_MAKE_A_CLAIM";
export const RESET_MAKE_A_CLAIM = "RESET_MAKE_A_CLAIM";
export const UPDATE_MAKE_A_CLAIM_PROPERTIES = "UPDATE_MAKE_A_CLAIM_PROPERTIES";
export const UPDATE_NAV_FROM_CLAIMS="UPDATE_NAV_FROM_CLAIMS";

export const updateMakeAClaimAction = (propName, propValue) => {
  return {
    type: UPDATE_MAKE_A_CLAIM,
    payload: { propName, propValue }
  };
};
export function updateNavigation(value ) {
 console.log(value);
  return {
        type: UPDATE_NAV_FROM_CLAIMS,
        payload: {
          navigationFromClaims:value
        }
  };
    
}

export const reset = () => {
  return {
    type: RESET_MAKE_A_CLAIM
  };
};

export const updateMakeAClaimProperties = props => {
  return {
    type: UPDATE_MAKE_A_CLAIM_PROPERTIES,
    payload: props
  };
};

export const updateIsNewClaimAndRelatedProperties = isNewClaim => {
  return (dispatch, getState) => {
    const { makeAClaimReducer, policyReducer } = getState();
    let propertiesToUpdate = {
      isNewClaim: isNewClaim
    };

    if (isNewClaim && makeAClaimReducer.authoriseTreatmentCondition !== 'isMusclesBonesJointsCondition') {
      if (policyReducer.selectedPolicy.IsInternational) {
        propertiesToUpdate = {
          ...propertiesToUpdate,
          action: "checkCover"
        };
      } else {
        propertiesToUpdate.nhsChemoRadioTreatmentType = null;
        if (
          makeAClaimReducer.claimType === AUTHORISE_TREATMENT ||
          makeAClaimReducer.claimBackOption === MEDICAL_TREATMENT
        ) {
          propertiesToUpdate = {
            ...propertiesToUpdate,
            action: "makeClaim",
            preAuth: "new"
          };
        }
      }
    } else {
      if (makeAClaimReducer.authoriseTreatmentCondition !== 'isMusclesBonesJointsCondition') {
        if (makeAClaimReducer.claimType === AUTHORISE_TREATMENT) {
          propertiesToUpdate = {
            ...propertiesToUpdate,
            action: "makeClaim"
          };
          if (!policyReducer.selectedPolicy.IsInternational) {
            propertiesToUpdate = {
              ...propertiesToUpdate,
              preAuth: "existing"
            };
          }
        } else if (makeAClaimReducer.claimBackOption === MEDICAL_TREATMENT) {
          propertiesToUpdate = {
            ...propertiesToUpdate,
            action: "invoiceSubmission",
            preAuth: null
          };
        }
      }
      else {
        if(isNewClaim === true){
          propertiesToUpdate = {
            ...propertiesToUpdate,
            action: "makeClaim",
            preAuth: "new"
          };
        }
        else{
          propertiesToUpdate = {
            ...propertiesToUpdate,
            action: "makeClaim",
            preAuth: "existing"
          };
        }
      }
    }

    dispatch({
      type: UPDATE_MAKE_A_CLAIM_PROPERTIES,
      payload: propertiesToUpdate
    });
  };
};

export const setIframeSrc = (action, preAuth) => {
  return async (dispatch, getState) => {
    const response = await getMakeAClaimUrl(
      getState().policyReducer.selectedPolicy.MembershipNumber,
      action,
      preAuth
    );
    dispatch({
      type: UPDATE_MAKE_A_CLAIM,
      payload: {
        propName: "iframeSrc",
        propValue: response
      }
    });
  };
};
